"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var MultiLayout_1 = __importDefault(require("./MultiLayout"));
var PrecomputedLayout_1 = __importDefault(require("./PrecomputedLayout"));
var ThrowingLayout = function ThrowingLayout() {
  _classCallCheck(this, ThrowingLayout);
  throw new Error('invalid layout name');
};
var PrecomputedMultiLayout = /*#__PURE__*/function (_MultiLayout_1$defaul) {
  _inherits(PrecomputedMultiLayout, _MultiLayout_1$defaul);
  function PrecomputedMultiLayout(json) {
    var _this;
    _classCallCheck(this, PrecomputedMultiLayout);
    // use ThrowingLayout because there is not supposed to be any creation
    // of new layouts in a precomputed layout
    _this = _possibleConstructorReturn(this, _getPrototypeOf(PrecomputedMultiLayout).call(this, ThrowingLayout));
    Object.entries(json).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        layoutName = _ref2[0],
        sublayoutJson = _ref2[1];
      _this.subLayouts.set(layoutName, new PrecomputedLayout_1.default(sublayoutJson));
    });
    return _this;
  }
  return PrecomputedMultiLayout;
}(MultiLayout_1.default);
exports.default = PrecomputedMultiLayout;